import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const HUBSPOT_ROUTES_MATCHER = /^\/(fr|en)(\/classement-entreprises)?\/?$/;

/**
 * Charge le script HubSpot sur la page d'accueil et le classement.
 */
export function HubspotChatRefresher() {
  const location = useLocation();
  const path = location.pathname || "/";

  useEffect(() => {
    if (!HUBSPOT_ROUTES_MATCHER.test(path)) return;

    const scriptList = document.querySelectorAll("script[type='text/javascript']");
    const hubspotScript = Array.from(scriptList).find((s) => s.id === "hs-script-loader");

    if (hubspotScript == null) {
      const script = document.createElement("script");
      script.id = "hs-script-loader";
      script.src = "//js-eu1.hs-scripts.com/148000743.js";
      script.async = true;
      script.defer = true;
      script.type = "text/javascript";
      document.body.appendChild(script);
    }
  }, [path]);

  return null;
}
